module.exports = __webpack_public_path__ + "static/media/completedOrders.b09bcea3.svg";